import { packMessage } from './nativeBridge';
import { baseConfig } from './baseConfig';
import { IS_WECHAT } from '../../constants';

export const aLink = (openUrl) => {
  window.location.assign(openUrl);
};

export const androidOutsideOpenApp = (params) => {
  const { path, query, trackAndroidUrl, androidDownloadUrl } = params;
  const downloadUrl =
    androidDownloadUrl || trackAndroidUrl || process.env.LIGHT_DOWNLOAD_ANDROID;
  const queryParams = path? { type: path } : {};
  if (query) {
    Object.assign(queryParams, query);
  }
  const paramsAndroid = {
    path: baseConfig.lighOutIntent,
    query: queryParams,
  };
  const openUrl = packMessage(paramsAndroid);
  if (!openUrl.match(/^light:\/\//)) {
    return [];
  }

  // 非微信环境下下载apk
  if (!IS_WECHAT) {
    const timer = setTimeout(() => {
      if (!document.hidden) {
        clearTimeout(timer);
        window.location.assign(downloadUrl);
      }
    }, 1000);
  }

  return trackAndroidUrl ? [trackAndroidUrl, openUrl] : [openUrl, openUrl];
};

/**
 * 生成 iOS 跳转链接
 * @param {object} params 跳转参数配置
 * @return {array} [iOS 跳转到畅片协议, iOS 微信跳转到畅片协议]
 */
export const iosOutsideOpenApp = (params = {}) => {
  const appSchema = packMessage(params);
  const { trackIosUrl } = params;
  let openUrl = baseConfig.iosUniversalLink;
  let copyUrl = baseConfig.pasteboardLink;
  if (appSchema) {
    openUrl += `?url=${appSchema}`;
    copyUrl += `?url=${appSchema}`;
  } else if (params.query && params.query.from) {
    // 打开app时，appSchema 返回空 不为空时packMessage会处理拼接好
    openUrl += `?from=${params.query.from}`;
  }
  openUrl = trackIosUrl || openUrl;
  return [openUrl, copyUrl];
};
